document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".featured-col-v2 .swiper-slider").forEach((colEle) => {
    const nextBtn = colEle.querySelector(".swiper-button-next");
    const prevBtn = colEle.querySelector(".swiper-button-prev");

    new Swiper(colEle, {
      slidesPerView: 1.2,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn
      },
      observer: true,
      observeParents: true,
      watchOverflow: false,
      breakpoints: {
        768:{slidesPerView:2.2},
        1024: {
          slidesPerView: 3.5
        }
      }
    });
  });
});



document.addEventListener("DOMContentLoaded", function() {
    const reviewthumbslider = new Swiper(".review-thumb-slider", {
            slidesPerView: 3,
            spaceBetween: 8
        }),
        reviewSliderEle = document.querySelector(".review-slider"),
        reviewSlider = new Swiper(reviewSliderEle, {
            slidesPerView: 1,
            rewind: !0,
            thumbs: {
                swiper: reviewthumbslider
            },
            navigation: {
                nextEl: ".review-slider .swiper-button-next",
                prevEl: ".review-slider .swiper-button-prev"
            }
        }),
        rsnext = document.querySelector(".review-slider-wrapper .swiper-button-next");
    rsnext && rsnext.addEventListener("click", function() {
        reviewSlider.slideNext()
    });
    const rsprev = document.querySelector(".review-slider-wrapper .swiper-button-prev");
    rsprev && rsprev.addEventListener("click", function() {
        reviewSlider.slidePrev()
    });
    const productThumbSlider = new Swiper(".product-thumb-slider", {
            slidesPerView: 5.3,
            spaceBetween: 10,
            breakpoints: {
                768: {
                    slidesPerView: 5.3,
                    spaceBetween: 16
                }
            },
            slideToClickedSlide: !0,
            watchSlidesVisibility: !0,
            watchSlidesProgress: !0
        }),
        productMainSlider = new Swiper(".product-main-slider", {
            slidesPerView: 1,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            },
            thumbs: {
                swiper: productThumbSlider
            }
        });
});